import { render, staticRenderFns } from "./TrangNhapMaKichHoat.vue?vue&type=template&id=2ce1bf98&"
import script from "./TrangNhapMaKichHoat.vue?vue&type=script&lang=js&"
export * from "./TrangNhapMaKichHoat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports